import React from 'react';
import { NavLink } from 'react-router-dom';
import withPrivileges from '@ubeya/shared-web/hoc/withPrivileges';
import useAccountUrl from './useAccountUrl';

const AccountLink = ({ to, ...props }) => {
  const newTo = useAccountUrl({ to });

  return <NavLink to={newTo} {...props} />;
};

export default withPrivileges(AccountLink);
